// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import OceanView from '../_raw/service/icon_ocean_view.svg';
import withIconProps from '../withIconProps';

export default withIconProps(OceanView);
